import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { Errors, LocalService, ProfileService, SellerService } from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import { CheckDateValidityPipe } from 'src/app/shared/pipe/check-date-validity.pipe';

@Component({
  selector: 'app-user-access-validation',
  templateUrl: './user-access-validation.component.html',
  styleUrls: ['./user-access-validation.component.scss']
})
export class UserAccessValidationComponent implements OnInit {

  userProfile;
  sliderData: any = [];
  showDots: boolean = false;
  errors: Errors = { errors: {} };
  fired = 0;
  redeemFlag: boolean = false;
  isSalesManager: boolean = false;
  isSeManager: boolean = false;
  isAdmin: boolean = false;
  slideConfig1 = { "slidesToShow": 1, "slidesToScroll": 1, dots: false, arrows: false, speed: 300, infinite: true, autoplay: true, autoplaySpeed: 5000 };
  @ViewChild('slickModal1') slickModal1: SlickCarouselComponent;
  pviEligible:boolean=false;
  constructor(readonly sanitizer: DomSanitizer, readonly router: Router, readonly sellerService: SellerService,
    readonly profileService: ProfileService, readonly popupMessageService: PopupMessageService) {
  }

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    if ((this.userProfile.grsUser && this.userProfile.active && !this.userProfile.company.profileComplete) || (this.userProfile.grsUser && !this.userProfile.active && !this.userProfile.onlyRedeemPoints)) {
      this.getPointsAvailable();
    }
    this.findPendingRoles();
 
        if(this.userProfile.pvieligible===false){
      this.pviEligible=true;
    }

  }




  checkDateValidity(slide) {
    let td = new Date();
    return CheckDateValidityPipe.prototype.transform(slide.startDate.substring(0, 10), slide.endDate.substring(0, 10), td.getFullYear() + '-' + Number(td.getMonth() + 1) + '-' + td.getDate());
    // return (new Date().getTime() <= new Date(slide.endDate).getTime() && new Date().getTime() >= new Date(slide.startDate).getTime()); 
  }



  htmlProperty(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getPointsAvailable() {
    this.sellerService.getPointsAvailable().subscribe(data => {
      if (data.pointsRemaining) {
        this.redeemFlag = true;
      }
    }, err => {
      this.errors = err;
    });
  }

  resendVerificationEmail() {
    var lang = localStorage.getItem('selectedLanguage');
    this.profileService.getEmailVerify(this.userProfile.id).subscribe((data) => {
      var msg = 'Email has been sent successfully.';
      if (lang == 'Korean') {
        msg = '이메일이 성공적으로 전송되었습니다.';
      }
      if (lang == 'Japanese') {
        msg = 'メールが正常に送信されました。';
      }
      this.popupMessageService.showSuccess(msg, 'success');
    }, err => {
      this.errors = err;
      var msg = 'Something went wrong. Please try again or contact support.';
      if (lang == 'Korean') {
        msg = '문제가 발생했습니다. 다시 시도하거나 지원 부서에 문의하십시오.';
      }
      if (lang == 'Japanese') {
        msg = '何かがおかしかった。再試行するか、サポートにお問い合わせください。';
      }
      this.popupMessageService.showError(msg, 'error');

    });
  }

  findPendingRoles() {
    const salesMngr = 'SALES_MANAGER';
    this.isSalesManager = this.userProfile.hasOwnProperty('userType') ? true : this.userProfile.pendingRole && this.userProfile.pendingRoles.find(item => item.name === salesMngr)
    const seManager = 'SE_MANAGER';
    this.isSeManager = this.userProfile.hasOwnProperty('userType') ? true : this.userProfile.pendingRole && this.userProfile.pendingRoles.find(item => item.name === seManager);
    const admin = 'COMPANY_ADMIN';
    this.isAdmin = this.userProfile.hasOwnProperty('userType') ? true : this.userProfile.pendingRole && this.userProfile.roles.find(item => item.name === admin);
  }

  resendApprovalEmail(salesManagerFlag) {
    if (salesManagerFlag) {
      const salesMngr = 'SALES_MANAGER';
      const salesMngrIndex = this.userProfile.pendingRoles.findIndex(item => item.name === salesMngr);
      const salesMngrID = this.userProfile.pendingRoles[salesMngrIndex].id;
      var lang = localStorage.getItem('selectedLanguage');
      this.profileService.resendApprovalEmail(this.userProfile.id, salesMngrID).subscribe((data) => {

        var msg = 'Email has been sent successfully.';
        if (lang == 'Korean') {
          msg = '이메일이 성공적으로 전송되었습니다.';
        }
        if (lang == 'Japanese') {
          msg = 'メールが正常に送信されました。';
        }
        this.popupMessageService.showSuccess(msg, 'success');
      }, err => {
        this.errors = err;
        var msg = 'Something went wrong. Please try again or contact support.';
        if (lang == 'Korean') {
          msg = '문제가 발생했습니다. 다시 시도하거나 지원 부서에 문의하십시오.';
        }
        if (lang == 'Japanese') {
          msg = '何かがおかしかった。再試行するか、サポートにお問い合わせください。';
        }
        this.popupMessageService.showError(msg, 'error');


      });
      return;
    }
    const seManager = 'SE_MANAGER';
    const seManagerIndex = this.userProfile.pendingRoles.findIndex(item => item.name === seManager);
    const seManagerID = this.userProfile.pendingRoles[seManagerIndex].id;
    var lang = localStorage.getItem('selectedLanguage');
    this.profileService.resendApprovalEmail(this.userProfile.id, seManagerID).subscribe((data) => {

      var msg = 'Email has been sent successfully.';
      if (lang == 'Korean') {
        msg = '이메일이 성공적으로 전송되었습니다.';
      }
      if (lang == 'Japanese') {
        msg = 'メールが正常に送信されました。';
      }
      this.popupMessageService.showSuccess(msg, 'success');
    }, err => {
      this.errors = err;
      var msg = 'Something went wrong. Please try again or contact support.';
      if (lang == 'Korean') {
        msg = '문제가 발생했습니다. 다시 시도하거나 지원 부서에 문의하십시오.';
      }
      if (lang == 'Japanese') {
        msg = '何かがおかしかった。再試行するか、サポートにお問い合わせください。';
      }
      this.popupMessageService.showError(msg, 'error');
    });
  }
  
  contactSupport() {
    this.router.navigateByUrl('/support');
  }
}
